import { SecuredUserManagementClient } from 'Core/Api/UserManagement/SecuredUserManagementClient';
import {
  SendEmailAddressConfirmationModel,
  ConfirmEmailAddressModel,
} from 'Core/Api/UserManagement/Api';
import Utility from 'Core/Utility';

export class EmailConfirmationHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  ResendConfirmationCode(userName: string) {
    let client = new SecuredUserManagementClient();
    client.showLoading = true;
    let request = new SendEmailAddressConfirmationModel();
    request.emailAddress = userName;

    return client.registration_SendEmailAddressConfirmationToken(request).
      catch(Utility.formatError);
  }

  ConfirmRegistration(userName: string, confirmationCode: string) {
    let client = new SecuredUserManagementClient();
    client.showLoading = true;
    let request = new ConfirmEmailAddressModel();
    request.username = userName;
    request.code = confirmationCode;
    return client
      .registration_ConfirmEmailAddress(request)
      .catch(Utility.formatError);
  }
}

interface UserApiError {
  ErrorMessage: string;
}
